import { defineStore } from 'pinia';
import { DespachoCatalogService } from '@/services/DespachoCatalogService';

const defaults = () => ({ action_label: 'Código Acción', result_label: 'Código Resultado', dictamen_label: 'Dictamen',
  dictamen_mode: 'disabled', auto_select_dictamen: false, auto_select_single: false, result_fallback: 'restricted' });

export const useManagementCatalogStore = defineStore('managementCatalog', {
  // Session-scoped: never persist another despacho's catalog in browser storage.
  state: () => ({ settings: defaults(), dictamenes: [], tenantKey: null, loaded: false, requestVersion: 0 }),
  getters: {
    autoSelectDictamen: state => state.settings.auto_select_dictamen === true,
    dictamenForResult: state => result => state.dictamenes.find(row => Number(row.id_codigo_resultado) === Number(result)),
  },
  actions: {
    clear() {
      this.requestVersion++;
      this.settings = defaults(); this.dictamenes = []; this.tenantKey = null; this.loaded = false;
    },
    seedPolicy(policy, tenantKey) {
      this.clear(); this.tenantKey = tenantKey;
      if (policy?.dictamen_mode) {
        this.settings.dictamen_mode = policy.dictamen_mode;
        this.settings.auto_select_dictamen = policy.dictamen_mode === 'result_one_to_one';
      }
    },
    async load() {
      const tenant = localStorage.getItem('DESPACHO');
      if (tenant !== this.tenantKey) this.clear();
      this.tenantKey = tenant;
      const version = ++this.requestVersion;
      const config = await DespachoCatalogService.management();
      if (version !== this.requestVersion || tenant !== localStorage.getItem('DESPACHO')) throw new Error('La sesión cambió. Recargue la gestión.');
      this.settings = { ...defaults(), ...config.settings,
        auto_select_dictamen: config.settings.dictamen_mode === 'result_one_to_one' };
      this.dictamenes = config.dictamenes;
      this.loaded = true;
      return config;
    },
  },
});
